
/**
 *下单时间
 * @param val
 * @returns {string}
 */
let orderFilter = val => {
    let arr = [
        "下单时间",
        "付款时间",
        "发货时间",
        "变更时间",
        "结束时间",
        "最早下单时间",
        "最后下单时间",
        "最早付款时间",
        "最后付款时间"
    ];
    return arr[val];
};
/**
 *订单类型
 * @param val
 * @returns {string}
 */
let orderListFilter = val => {
    let arr = [
        "一口价",
        "拍卖",
        "一口价、拍卖",
        "自动发货,担保交易",
        "旺店入门版交易",
        "旺店标准版交易",
        "直冲",
        "货到付款",
        "分销",
        "游戏装备",
        "shopEX交易",
        "万网交易",
        "统一外部交易",
        "o2o交易",
        "万人团",
        "无付款订单",
        "预授权0元购机交易"
    ];
    return arr[val];
};
/**
 *主订单状态
 * @param val
 * @returns {string}
 */
let mainOrderStatusFilter = val => {
    let arr = [
        "没有创建支付宝交易",
        "等待买家付款",
        "卖家部分发货",
        "等待卖家发货",
        "等待买家确认收货,即:卖家已发货",
        "买家已签收,货到付款专用",
        "交易成功",
        "付款以后用户退款成功，交易自动关闭",
        "付款以前，卖家或买家主动关闭交易",
        "国际信用卡支付付款确认中",
        "0元购合约中",
        "拼团中订单或者发货强管控的订单，已付款但禁止发货"
    ];
    let backarr=[];
    if(Array.isArray(val)){
        for(let i=0;i<val.length;i++){
           backarr.push(arr[val[i]]);
        }
        return backarr.join(" ");
    }
    return arr[val];
};
let childOrderStatusFilter = val => {
    let arr = [
        "没有创建支付宝交易",
        "等待买家付款",
        "等待卖家发货，即：买家已付款",
        "等待买家确认收货,即:卖家已发货",
        "买家已签收,货到付款专用",
        "交易成功",
        "付款以后用户退款成功，交易自动关闭",
        "付款以前，卖家或买家主动关闭交易",
        "国际信用卡支付付款确认中"
    ];
    let backarr=[];
    if(Array.isArray(val)){
        for(let i=0;i<val.length;i++){
           backarr.push(arr[val[i]]);
        }
        return backarr.join(" ");
    }
    return arr[val];
};
let zipToaddress=val=>{
    if(Array.isArray(val)){
        if(val.length===1 && val[0] ==""){
            return  '全部';
        }else{
            return val.join(" ");
        }
    }
};
/**
 *交易来源
 * @param val
 * @returns {string}
 */
let payStatusFilter = val => {
    let arr = [
        "",
        "手机端",
        "PC端",
        "聚划算",
    ],
    str = '';
    for (var i =0;i<val.length;i++){
        str = str +','+ arr[val[i]]
    }
    return str;
};
/**
 *交易来源
 * @param val
 * @returns {string}
 */
let customerStatusFilter = val => {
    let arr = [
        "客单价",
        "笔单价",
    ];
    return arr[val];
};
let goodsStatusFilter = val => {
    let arr = [
        "商品ID",
        "商品标题",
    ];
    return arr[val];
};
let buyerStatusFilter = val => {
    let arr = [
        "不包含",
        "包含",
    ];
    return arr[val];
};
let suerBuyStatusFilter = val => {
    let arr = [
        "非预售",
        "预售",
    ];
    if(val===''){return '不限';}
    return arr[val];
};
let buyMoneyStatusFilter = val => {
    let arr = [
        "未付定金",
        "已付定金,未付尾款",
        "定金和尾款都付",
        "卖家已发货",
        "交易成功",
    ];
    return arr[val];
};
/**
 *评价状态
 * @param val
 * @returns {string}
 */
let sendStatusFilter = val => {
    let arr = [
        "买家未评",
        "买家已评",
        "买家未评,卖家已评",
        "买家未评,卖家未评",
        "买家已评,卖家未评",
        "卖家未评",
        "卖家已评",
        "卖家已评,买家已评",
    ];
    return arr[val];
};
/**
 *中国标准时间转换
 * @param str
 * @returns 时间数字字符串  如yyyy-mm-dd hh:mm:ss
 */
let timeFilter = time => {
    var day1 = new Date(time);
    day1.setTime(day1.getTime());
    var yy = day1.getFullYear(),
        mm = (day1.getMonth()+1),
        dd = day1.getDate(),
        hh = day1.getHours(),
        min = day1.getMinutes(),
        ss = day1.getSeconds();
    if(parseInt(mm)<10){mm = '0'+mm}
    if(parseInt(dd)<10){dd = '0'+dd}
    if(parseInt(hh)<10){hh = '0'+hh}
    if(parseInt(min)<10){min = '0'+min}
    if(parseInt(ss)<10){ss = '0'+ss}
    // console.log(yy +'-'+mm+'-'+dd+' '+hh+':'+min+':'+ss);
    return yy +'-'+mm+'-'+dd+' '+hh+':'+min+':'+ss;
};
let groupStatuaFilter = val => {
    let arr = [
        "",
        "静态分组",
        "动态分组",
        "文件导入分组",
        "手动输入分组"
    ];
    return arr[val];
};
let lengthContent = (len,flag,addNum) =>{
    // console.log(len);
    // console.log(flag);
    let length = len&&len.length>0?len.length:'';
    if(typeof flag === 'number'){
        if(addNum){
            return addNum * Math.ceil(length/flag);
        }else {
            return Math.ceil(length/flag);
        }
    }else {
        return length
    }
};
let numStr = (val) =>{
    return val ? val : '0';
};
export {
    groupStatuaFilter,
    timeFilter,
    buyMoneyStatusFilter,
    suerBuyStatusFilter,
    sendStatusFilter,
    buyerStatusFilter,
    goodsStatusFilter,
    orderFilter,
    orderListFilter,
    mainOrderStatusFilter,
    childOrderStatusFilter,
    payStatusFilter,
    customerStatusFilter,
    lengthContent,
    zipToaddress
}